import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'
import { useMutation } from 'react-query'
import useCache from '../use-cache'

const useJob = ({
    jobId,
    onSuccess = () => {},
    onError = () => {},
}) => {
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: cacheKeys.JOBS, onReload: onSuccess })
    const { api, endpoints, url } = useApi()

    const [ runJob, { isLoading: isRunning } ] = useMutation(
        () => api.post(url(endpoints.job, { jobId }), {}),
        {
            onSuccess: clearCache,
            onError,
        }
    )

    return {
        isRunning,
        runJob,
    }
}

export default useJob